export const APP_TITLE = "Catalogue";
export const JWT_PERIOD = 40 * 60 * 1000;
export const MONTHS = {
  short: ["jan", "fev", "mars", "avr", "mai", "juin", "juill", "août", "sept", "oct", "nov", "dec"],
  long: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
};
